.container {
  z-index: var(--layer-tooltip);
  position: fixed;
  min-height: 5rem;
  display: flex;
  flex-direction: column;
  bottom: 2.4rem;
  right: 2.4rem;
  gap: 0.8rem;
}
